import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PackageUtilizationExpectation, PackageUtilizationExpectationUpdate } from 'types';
import { client } from 'utils/api-client';

import { PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY } from './useAutoCompletePackage';
import { PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY } from './useExpectations';
import { PACKAGE_UTILIZATION_REPORT_QUERY_KEY } from './usePackageUtilization';

type EditExpectationProps = {
  expectationId: string;
  expectation: PackageUtilizationExpectationUpdate;
};

export default function useEditExpectation(): UseMutationResult<
  AxiosResponse<PackageUtilizationExpectation[]>,
  AxiosError<ErrorMessage>,
  EditExpectationProps
> {
  const queryClient = useQueryClient();

  const editExpectation = ({
    expectationId,
    expectation,
  }: EditExpectationProps): Promise<AxiosResponse<PackageUtilizationExpectation[]>> => {
    return client.put(`/package-utilization-expectations/${expectationId}/`, expectation);
  };

  return useMutation(editExpectation, {
    onSuccess: () => {
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_EXPECTATIONS_QUERY_KEY]);
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_EXPECTATIONS_AUTO_COMPLETE_QUERY_KEY]);
      queryClient.invalidateQueries([PACKAGE_UTILIZATION_REPORT_QUERY_KEY]);
    },
  });
}
